import { HeritageBuildingHomeUiOuterStucture } from "./HeritageBuildingHome";

const HeritageBuildingHome3 = () => (
  <HeritageBuildingHomeUiOuterStucture currentPage={3}>
    <h5 className="fontSizeClass">
      <strong>
        425E. Powers and functions of Heritage Conservation Committee :
      </strong>
    </h5>
    <p>
      The Heritage Conservation Committee shall have the power to function
      independent of the Municipal Building Committee for purpose of
      preservation, conservation and maintenance of heritage buildings in so far
      as such power does not offend any other provisions of this Act or the
      rules made thereunder relating to construction or use of building :
    </p>
    <p>
      Provided that for erection or re-erection in a heritage building or part
      thereof, or for restoration of any heritage building to its old shape,
      design or beauty in the case of unlawful demolition, or for making any
      change of internal or external wall, structural pattern, floor, roof,
      interior or exterior architectural floor, facade or skyline, or for any
      other change, or a heritage building, the provisions of chapters XXII and
      XXIII of this Act and the rules made thereunder shall apply mutatis
      mutandis.
    </p>
    <h5>
      425F. Power of Corporation to require, purchase or take on lease heritage
      building :
    </h5>
    <p>
      Subject to the other provisions of this Act, the Corporation may acquire,
      purchase or take on lease any heritage building for the purpose of
      preservation and conservation thereof : Provided that in the case of a
      heritage building declared as such for the purpose of preservation and
      conservation as required under sub-clause (ii) of clause (a) of
      sub-section (4) of section 31 of the West Bengal Town and Country
      (Planning and Development) Act, 1979 (West Ben. Act XIII of 1979), the
      approval of the concerned department of the State Government shall be
      taken.
    </p>
    <h5>
      425G. Transfer of right of development for the purpose of acquisition by
      agreement :
    </h5>
    <p>
      When the owner of any heritage building is not willing to preserve or
      conserve any heritage building, the Municipal Commissioner may, for the
      purpose of acquisition of such heritage building by agreement and on the
      recommendation of the Heritage Conservation Committee and with the
      approval of the Mayor-in-Council, allow the transfer of right of
      development of such heritage building, which shall be heritable and
      transferable, to the owner of such heritage building in such manner, and
      subject to such conditions, as may be prescribed.
    </p>
    <h5>
      425H. Right of access to heritage building acquired by Corporation :
    </h5>
    <p>
      Subject to such rules or regulations as may be made under this Act, every
      person shall have the right of access to any heritage building acquired by
      the Corporation.
    </p>
    <h5>425I. Sub-lease of heritage building :</h5>
    <p>
      The Corporation shall have the right to allow the transfer of right of
      development to the lessee of a heritage building where the unexpired
      period of the term of lease is for 90 years, and to take the heritage
      building on sub-lease by agreement, if there is provision for such
      sub-lease in the deed executed between the owner and the lessee, provided
      that the question of payment of premium or rent in such case to the owner
      shall not, notwithstanding any agreement in this behalf, arise, and if the
      owner as confirming party to the agreement waives the right to receive any
      further payment of such premium or rent.
    </p>
    <h5>
      425J.Permission of concerned department of State Government before
      acquisition of heritage building :
    </h5>
    <p>
      If the Corporation considers that it is necessary to acquire any building
      declared as a heritage building for the purpose of preservation and
      conservation as required under sub-clause (ii) of clause (a) of
      sub-section (4) of section 31 of the West Bengal Town and Country
      (Planning and Development) Act. 1979, by agreement or under the Land
      Acquisition Act, 1894 (1 of 1894), permission of the concerned Department
      of the State Government shall be taken before such acquisition.
    </p>
    <h5>425K. Power to exempt rates and taxes, etc. on heritage building :</h5>
    <p>
      If the owner of a heritage building enters into an agreement with the
      Corporation to maintain, preserve and conserve such heritage building
      properly at his own expenses, the Corporation may, in such case, exempt
      wholly or partly the owner of such heritage building from payment of rates
      of taxes or fees for supply of water or any other charge in respect of
      such heritage building.
    </p>
    <h5>
      425L. Agreement with owner of heritage building pending acquisition :
    </h5>
    <ol className="kmc-function-list">
      {[
        {
          label:
            "The Municipal Commissioner may, pending acquisition of a heritage building by the Corporation under this Act and with the approval of the Mayor-in-Council, propose to the owner of such heritage building to enter into an agreement with the Corporation for a specified period for the maintenance of such heritage building.",
          children: [],
        },
        {
          label:
            "The agreement as aforesaid may provide for all or any of the following matters :-",
          children: [
            {
              label:
                "maintenance of the heritage building by the owner or by any other person willing to maintain the said heritage building;",
              children: [],
            },
            {
              label:
                "custody of the heritage building and the duties of the person who may be employed to watch it;",
              children: [],
            },
            {
              label: "the restrictions of the owner's right -",
              children: [
                "to use the heritage building for any other purpose detrimental to its conservation,",
                "to charge any fee for entry into, or inspection of, the heritage building, and",
                "to build on or near the site of the heritage building.",
              ],
            },
          ],
        },
      ].map(({ label, children }, index) => (
        <li key={index}>
          {label}
          {children.length > 0 && (
            <ol type="a">
              {children.map(({ label, children }, childIndex) => (
                <li key={childIndex}>
                  {label}
                  <ol type="i">
                    {children.map((subChild, subChildIndex) => (
                      <li key={subChildIndex}>{subChild}</li>
                    ))}
                  </ol>
                </li>
              ))}
            </ol>
          )}
        </li>
      ))}
    </ol>

    <h5>
      425M. Voluntary contribution and agreement with any voluntary
      organisation, person or company :
    </h5>
    <ol className="kmc-function-list">
      {[
        "The Municipal Commissioner may receive voluntary contributions towards the cost of maintaining any heritage building and may give order as to the management and application of such contributions for the purpose of preservation and conservation of such heritage building.",
        "Subject to the approval of the Mayor-in-Council, the Municipal Commissioner may enter into any agreement with any person or voluntary organisation or company, whether incorporated or not, willing to preserve and conserve any heritage building on such terms and conditions as the Municipal Commissioner may determine.",
      ].map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ol>
  </HeritageBuildingHomeUiOuterStucture>
);

export default HeritageBuildingHome3;
